import React from 'react';
import { shape } from 'prop-types';
import StoreHeader from '../../features/store-header/store-header';
import Gallery from '../../features/gallery/gallery.desktop';
import Onboarding from '../../features/onboarding/onboarding.desktop';

// Head Section
import ItemStatusHead from '../../features/item-status/head';

import RedirectFromStatus from '../../features/item-status/redirected-from';
import GroupedHeader from './sections/grouped-header';
import KYCNotification from '../../features/kyc-notification/kyc-notification.desktop';

// Short Description
import Bookmark from '../../features/bookmark';

import Header from '../../features/header/header.desktop';
import Price from '../../features/price/price.desktop';
import PaymentSummary from '../../features/payment-summary/payment-summary.desktop';
import ItemStatusShortDescription from '../../features/item-status/short-description';
import QuestionsShortDescription from '../../features/questions-vis/questions-vis-short-description.desktop';
import GroupedMainActions from '../../features/grouped-main-actions';
import BudgetSentMessage from '../../features/service-message/budget-sent-message';
import NewBugdetMessage from '../../features/service-message/new-budget-message';
import ReportProblem from '../../features/report-problem/report-problem.desktop';
import Grid from '../../../../../components/grid';

// Content Left
import TechnicalSpecifications from '../../features/technical-specifications/technical-specifications.desktop';

import HighlightedSpecsAttrs from '../../features/highlighted-specs/highlighted-specs-attrs.desktop';
import Location from '../../features/location/location.desktop';
import Description from '../../features/description/description.desktop';
import ReviewsCapability from '../../../../../components/reviews-capability/reviews.desktop';
import BudgetDemand from '../../features/budget-demand/budget-demand';

// Content Right
import StickyWrapper from '../../features/sticky-wrapper';

import SellerProfile from '../../features/seller-profile/seller-profile';
import SellerReputation from '../../features/seller-reputation/seller-reputation';
import PaymentMethods from '../../features/payment-methods/payment-methods.desktop';
import SecurityTips from '../../features/security-tips/security-tips.desktop';
import ServiceFaq from '../../features/service-faq/service-faq';
import RelatedServices from '../../features/related-services';

// Content Bottom
import Denounce from '../../features/denounce';

import BillboardAd from '../../features/billboard-ad';
import BillboardAdn from '../../features/billboard-adn/billboard-adn-bottom';

// Snackbars
import Snackbar from '../../features/service-snackbar/service-snackbar';

import SnackbarPrincipal from '../../features/snackbar';

// General
import View from '../view';

import GroupedShareBookmark from '../../features/grouped-share-bookmark';
import GiftRegistry from '../../features/gift-registry';

const ServicesDesktop = props => (
  <View {...props} vertical="services">
    <Onboarding />
    <Grid.Container className="ui-pdp-container--top">
      <Grid.Row>
        <Grid.Col className="ui-vip-core-container--head">
          <RedirectFromStatus />
          <GroupedHeader />
          <ItemStatusHead />
          <KYCNotification />
        </Grid.Col>
      </Grid.Row>
    </Grid.Container>
    <Grid.Container>
      <StoreHeader />
    </Grid.Container>
    <Grid.Container className="ui-pdp-container--pdp">
      <Grid.Row id="ui-pdp-main-container" className="ui-pdp-container__row--reverse ui-pdp--relative  pb-40">
        <Grid.Col className="ui-pdp-container--column-right mt-24 mr-24">
          <StickyWrapper columnName="right">
            <Grid.Row className="ui-pdp-component-list">
              <Grid.Col
                size={2}
                className="ui-vip-core-container--short-description ui-vip-core-container--column__right"
              >
                <Header>
                  <Bookmark showLabel={false} />
                </Header>
                <Price />
                <PaymentSummary />
                <ItemStatusShortDescription />
                <QuestionsShortDescription enableRedirectAction />
                <BudgetSentMessage />
                <GroupedMainActions />
                <NewBugdetMessage />
                <ReportProblem />
                <GiftRegistry />
                <GroupedShareBookmark className="mt-24" showOnlyForWishlistVariant />
              </Grid.Col>
            </Grid.Row>
            <Grid.Row className="ui-pdp-component-list ui-vip-content-right mt-16">
              <SellerProfile />
              <SellerReputation />
              <ServiceFaq />
              <PaymentMethods />
              <RelatedServices />
              <SecurityTips />
            </Grid.Row>
          </StickyWrapper>
        </Grid.Col>
        <Grid.Col className="ui-pdp-container--column-left" size={2}>
          <Grid.Row>
            <Grid.Col size={2}>
              <Gallery />
            </Grid.Col>
          </Grid.Row>
          <Grid.Col className="ui-vip-core-container--content-left">
            <TechnicalSpecifications />
            <HighlightedSpecsAttrs />
            <Description />
            <Location />
            <Grid.Col size={3}>
              <ReviewsCapability />
            </Grid.Col>
            <BudgetDemand />
          </Grid.Col>
        </Grid.Col>
      </Grid.Row>
    </Grid.Container>
    <Grid.Container className="ui-vip-core ui-pdp-container--bottom">
      <Denounce />
      <BillboardAd />
      <Snackbar />
      <BillboardAdn />
    </Grid.Container>
    <SnackbarPrincipal />
  </View>
);

ServicesDesktop.propTypes = {
  initialState: shape().isRequired,
};

export default ServicesDesktop;
